import { getEntries } from '../../utils/entries';
export function sortByUISettings(field, fallback) {
    return (first_object, second_object) => {
        const [first_ui_settings, second_ui_settings] = [
            first_object.ui_settings[field],
            second_object.ui_settings[field],
        ];
        if (first_ui_settings == null && second_ui_settings == null) {
            return fallback?.(first_object, second_object) ?? 0;
        }
        if (first_ui_settings == null) {
            return -1;
        }
        if (second_ui_settings == null) {
            return +1;
        }
        if (first_ui_settings < second_ui_settings) {
            return -1;
        }
        if (first_ui_settings > second_ui_settings) {
            return +1;
        }
        return fallback?.(first_object, second_object) ?? 0;
    };
}
function isElementUISettingsEqual(prev_ui_settings, ui_settings) {
    if (!prev_ui_settings || !ui_settings) {
        return false;
    }
    const { internal_order, ...common_prev_ui_settings } = ui_settings;
    const is_values_equal = getEntries(common_prev_ui_settings).every(([key, value]) => {
        return value === prev_ui_settings[key];
    });
    return is_values_equal;
}
export function isInternalOrderEqual(prev_internal_order, internal_order) {
    if (!prev_internal_order || !internal_order) {
        return false;
    }
    const is_internal_order_equal = Object.entries(internal_order).every(([key, ui_settings]) => {
        const id = Number(key);
        const prev_ui_settings = prev_internal_order[id];
        const is_ui_settings_equal = isElementUISettingsEqual(prev_ui_settings, ui_settings);
        return is_ui_settings_equal;
    });
    return is_internal_order_equal;
}
export function isDeviceUISettingsEqual(prev_device_ui_settings, device_ui_settings, tab_key) {
    const tab_ui_settings = device_ui_settings[tab_key] || {};
    const tab_prev_ui_settings = prev_device_ui_settings[tab_key] || {};
    const is_device_ui_settings_equal = Object.entries(tab_ui_settings).every(([key, panel_ui_settings]) => {
        const panel_key = key;
        const prev_panel_ui_settings = tab_prev_ui_settings[panel_key];
        const is_internal_order_equal = isInternalOrderEqual(prev_panel_ui_settings?.internal_order, panel_ui_settings.internal_order);
        const is_ui_settings_equal = is_internal_order_equal &&
            isElementUISettingsEqual(prev_panel_ui_settings, panel_ui_settings);
        return is_ui_settings_equal;
    });
    return is_device_ui_settings_equal;
}
